import React from 'react';
import styled from 'styled-components';
import { Button, Box, Icon } from '@openfin/ui-library';
import { AnimatePresence } from 'framer-motion';

import { CardDropdownMenu } from './CardDropdownMenu';
import { NftButtonOptions } from './CardButtonContainer';

interface DropDownBtnProps {
  buttons: NftButtonOptions[];
}

export const CardDropdownButton: React.FC<DropDownBtnProps> = (props) => {
  const { buttons } = props;
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const ignoreBlur = React.useRef<boolean>(false);
  const kind = buttons[0].cta ? 'primary' : 'textOnly';

  const handleDropdownMouseDown = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    if (!dropdownOpen) {
      setDropdownOpen(true);
    } else {
      setDropdownOpen(false);
      ignoreBlur.current = true;
    }
  };

  const handleDropdownOnClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleBlur: React.FocusEventHandler = () => {
    if (!ignoreBlur.current) {
      setDropdownOpen(false);
    }
  };

  return (
    <Container>
      <AnimatePresence>
        {dropdownOpen && (
          <CardDropdownMenu buttonData={buttons} onBlur={handleBlur} ignoreBlurRef={ignoreBlur} />
        )}
      </AnimatePresence>
      <NftDropDownButton
        kind={kind}
        onClick={handleDropdownOnClick}
        onMouseDown={handleDropdownMouseDown}
        size="small"
        // Needed for tests
        className="notification-button-dropdown"
      >
        <Icon icon="CaretUpIcon" size="large" />
      </NftDropDownButton>
    </Container>
  );
};

const Container = styled(Box)`
  position: relative;
  margin-left: -${(props) => props.theme.px.small};
`;

export const NftDropDownButton = styled(Button)`
  position: relative;
  max-width: ${(props) => props.theme.px.xxlarge};
  justify-content: center;
`;
